// State for the two-question step every new account answers before the tour:
// "What best describes your work?" then "Who'll be using it?". The option list
// comes from the server (ListUsagePurposeOptions); nothing here names an option.
// The server stores at most this many characters for "Other (tell us)".
export const OTHER_DESCRIPTION_MAX_LENGTH = 500;
export const STEP_WORK = 1;
export const STEP_TEAM = 2;
export const STEP_COUNT = 2;
export const initialStepState = () => ({
    step: STEP_WORK,
    usagePurpose: null,
    requiresDescription: false,
    otherDescription: '',
    teamSize: null,
});
export const selectUsagePurpose = (state, option) => ({
    ...state,
    usagePurpose: option.value,
    requiresDescription: option.requiresDescription,
});
export const setOtherDescription = (state, text) => ({
    ...state,
    otherDescription: text.slice(0, OTHER_DESCRIPTION_MAX_LENGTH),
});
export const selectTeamSize = (state, value) => ({
    ...state,
    teamSize: value,
});
export const canContinueFromWork = (state) => {
    if (state.usagePurpose === null)
        return false;
    if (!state.requiresDescription)
        return true;
    const trimmed = state.otherDescription.trim();
    return trimmed.length > 0 && trimmed.length <= OTHER_DESCRIPTION_MAX_LENGTH;
};
export const goToTeam = (state) => canContinueFromWork(state) ? { ...state, step: STEP_TEAM } : state;
export const goBackToWork = (state) => ({ ...state, step: STEP_WORK });
export const canSave = (state) => state.step === STEP_TEAM && canContinueFromWork(state) && state.teamSize !== null;
// The description is only sent with the option that asks for it, so a text
// typed under "Other" and then abandoned for another card is never stored.
export const buildSubmission = (state) => {
    if (!canSave(state) || state.usagePurpose === null || state.teamSize === null) {
        throw new Error('The usage purpose step is not complete');
    }
    return {
        usagePurpose: state.usagePurpose,
        otherDescription: state.requiresDescription ? state.otherDescription.trim() : '',
        teamSize: state.teamSize,
    };
};
